import React from "react";
import Metadata from "@/components/Metadata";
import { createClient } from "../../prismicio";
import PrivacyPolicyBlog from "@/components/PrivacyPolicy";
import Layout from "@/components/Layout";

function PrivacyPolicy({ page, globals }) {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/privacy-policy"
      />
      <PrivacyPolicyBlog
        title={pageData?.title}
        description={pageData?.description}
      />
    </Layout>
  );
}

export default PrivacyPolicy;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("privacy_policy");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
